var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Forbidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 13a25 25 0 100 49.999A25 25 0 0038 13zm0 4a20.9 20.9 0 0113.36 4.81L21.81 51.36A21 21 0 0138 17zm0 42a20.9 20.9 0 01-13.36-4.81l29.55-29.55A21 21 0 0138 59z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Forbidden.06259c43.svg";
export { SvgJ2Forbidden as ReactComponent };